import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../styles/common/progLangList.module.css'
import { selectProgLang } from '../../actions/commonActions'

export class ProgLangListItem extends Component {
    render() {
        const { itemContainer, title } = styles;
        const { progLang } = this.props;

        return (
            <div className={itemContainer} onClick={() => this.props.selectProgLang(progLang.id)}>
                <span className={title}>{progLang.name}</span>
            </div>
        )
    }
}

export default connect(null, {selectProgLang})(ProgLangListItem)
